import { DocInfo } from "../datastore/models"
import { ApiResult, ApiService } from "../interfaces/api"
import { LoadStatus, setDocStatus } from "../redux/slices/docMeta"
import { AppDispatch } from "../redux/store"
import { localStore } from "../storage/storage"
import { getLogger } from "loglevel"

const log = getLogger("resourceRequests")

export const requestAndStoreDoc = async (
  dispatch: AppDispatch,
  docInfo: DocInfo,
  services: any
) => {
  const api: ApiService = services.api

  dispatch(
    setDocStatus({
      docId: docInfo.id,
      docStatus: { loadStatus: LoadStatus.LOADING }
    })
  )

  const getDocResult = await api.getDocument(`${docInfo.company}/${docInfo.id}`)
  const lastRequestTime = new Date().toISOString()
  
  if (getDocResult.result === ApiResult.SUCCESS) {
    await localStore.set(`docs/${docInfo.id}`, getDocResult.responseData)

    dispatch(
      setDocStatus({
        docId: docInfo.id,
        docStatus: {
          loadStatus: LoadStatus.COMPLETE,
          lastModifiedDate: docInfo.lastModifiedDate || "",
          lastLoaded: lastRequestTime,
          lastRequestTime
        }
      })
    )
    return {
        loadStatus: LoadStatus.COMPLETE,
        docData: getDocResult.responseData
    }

  } else {
    log.debug(`requestDocs:error loading document ${docInfo.id}`)
    dispatch(
      setDocStatus({
        docId: docInfo.id,
        docStatus: {
          loadStatus: LoadStatus.LOAD_ERROR,
          lastModifiedDate: docInfo.lastModifiedDate || "",
          lastRequestTime
        }
      })
    )

    return {
        loadStatus: LoadStatus.LOAD_ERROR,
        docData: null
    }
  }
}
